import React from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import Drawer from '@material-ui/core/Drawer'
import { Avatar, makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Navbar from './Navbar'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import ShoppingBasketOutlinedIcon from '@material-ui/icons/ShoppingBasketOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import { useHistory, useLocation } from 'react-router'
import AddToQueueSharpIcon from '@material-ui/icons/AddToQueueSharp';
import ReceiptSharpIcon from '@material-ui/icons/ReceiptSharp';
const drawerWidth = 270

const useStyles = makeStyles((theme) => {
  return {
    page: {
      background: '#F9FAFC',
      width: '100%',
      padding: theme.spacing(2),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      paddingLeft: 8,
      paddingRight: 8,
    },

    root: {
      display: 'flex',
    },
    active: {
      background: '#F6F9FD',
      color: '#2C3590',
      borderRadius: 4,
      borderLeft: '3px Solid #15B9EC',
    },
    activeIcon: {
      color: '#2C3590',
    },
    notActive: {
      borderLeft: '3px Solid transparent',
    },
    appbar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    drawerContainer: {
      overflow: 'auto',
    },

    avtrLarge: {
      width: 100,
      height: 100,
      fontSize: 24,
      background: '#ecfaff',
      color: '#23c0f1',
    },
    avtrWrap: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
    avtarName: {
      fontSize: '13px!important',
      fontWeight: '700',
      marginTop: 16,
      textTransform: 'uppercase',
    },
    avtarDesignation: {
      fontSize: '11px!important',
      fontWeight: '500',
      textTransform: 'uppercase',
      color: '#575757',
      letterSpacing: '0.085rem',
    },
  }
})

const DrawerMenu = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const Name = JSON.parse(localStorage.getItem('name'));
  const Designation = JSON.parse(localStorage.getItem('role'))

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardOutlinedIcon />,
      path: '/Admin/dashboard',
    },
    {
      text: 'Treatment Add',
      icon: <ShoppingBasketOutlinedIcon />,
      path: '/Admin/treatment',
    },

    {
      text: 'Treatment Details Add',
      icon: <AddToQueueSharpIcon />,
      path: '/Admin/treatment_Details',
    },
    {
      text: 'Billing',
      icon: <ReceiptSharpIcon />,
      path: '/Admin/Billing',
    },
  ]
  return (
    <div>
      <Navbar />
      <Drawer
        className={classes.drawer}
        variant='permanent'
        anchor='left'
        classes={{ paper: classes.drawerPaper }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <div className={classes.avtrWrap}>
            <Avatar className={classes.avtrLarge}>
              {Name[0].toUpperCase()}
            </Avatar>
            <Typography className={classes.avtarName} variant='h6'>
              {Name ? Name : 'Admin'}
            </Typography>
            <Typography className={classes.avtarDesignation} variant='h6'>
              {Designation ? Designation : 'Designation'}
            </Typography>
          </div>
          <Divider />
          <List>
            {menuItems.map((menu) => (
              <ListItem
                button
                key={menu.text}
                onClick={() => history.push(menu.path)}
                className={
                  location.pathname === menu.path
                    ? classes.active
                    : classes.notActive
                }
              >
                <ListItemIcon
                  className={
                    location.pathname === menu.path ? classes.activeIcon : null
                  }
                >
                  {menu.icon}
                </ListItemIcon>
                <ListItemText>{menu.text}</ListItemText>
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>
    </div>
  )
}


export default DrawerMenu
